import { c as __read, e as __spreadArray, _ as __assign, d as __rest, f as __values } from './tslib.es6-ebb56484.js';
import { c as cn } from './index-9d6795ea.js';
import React__default, { useState, useRef, useEffect, useMemo } from 'react';
import { useIsMobile, useStyles, useBoolean, useTheme } from '@sravni/react-utils';
import { hasItem, generateKeyFromTab, normalizeTabs, normalizeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS_LIST, INSURANCE_OFFERS, COMMON_OFFERS_LIST, EDUCATION_OFFERS_LIST, BUSINESS_OFFERS_LIST, INSURANCE_OFFERS_LIST, OFFERS_TABS_DEFAULT_ORDER } from '@sravni/ugc/lib/specialOffers/lists';
import { Tabs, Accordion, Badge, Menu, Typography, Dialog, Sheet } from '@sravni/react-design-system';
import { a as getTabTitleTo, g as getTabTitle } from './getTitle-6237901b.js';
import { Space } from '@sravni/react-design-system/lib/Space';
import { i as isEqual_1 } from './isEqual-9167b1e9.js';
import crypto from 'crypto';
import { B as BlockListPreloader } from './Preloader-30f97917.js';

var generateHeadingTitle = function (tabType) {
    if (hasItem(ACTIONS_LIST, tabType)) {
        return "\u0412\u0430\u0448\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F";
    }
    return "\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F";
};

var modules_31ab199a = {"tabPane":"_3xnsw4","accordion-item":"_1jym3n","menu":"_tngoq4","menu__badge":"_10rrmow","menu__item":"_1o11d3o","dialog":"_1ktxq4k"};
/*SRAVNI__src/innerComponents/UltimateSpecialOffers/src/components/Headings/Headings.module.scss__SRAVNI*/;

var HorizontalHeading = function (_a) {
    var element = _a.element, tabs = _a.tabs, onTabChange = _a.onTabChange, activeTabType = _a.activeTabType, horizontalText = _a.horizontalText, _b = _a.showOneHorizontalTabHeading, showOneHorizontalTabHeading = _b === void 0 ? false : _b;
    var isMobile = useIsMobile();
    var headingText = horizontalText
        ? horizontalText
        : "".concat(generateHeadingTitle(activeTabType), " ").concat(getTabTitleTo(activeTabType));
    var heading = React__default.cloneElement(element, { className: cn('h-mb-20', element.props.className) }, headingText);
    if (!showOneHorizontalTabHeading && tabs.length === 1) {
        return heading;
    }
    var handleTabChange = function (key) {
        onTabChange(tabs[key]);
    };
    return (React__default.createElement(React__default.Fragment, null,
        heading,
        React__default.createElement(Tabs, { onChange: handleTabChange, className: isMobile ? 'h-mb-20' : 'h-mb-24', key: JSON.stringify(tabs) }, tabs.map(function (tab) {
            return (React__default.createElement(Tabs.TabPane, { key: generateKeyFromTab(tab), title: getTabTitle(tab), className: modules_31ab199a.tabPane }));
        }))));
};

var allTabsForMenu = [
    { label: 'Личные финансы', list: COMMON_OFFERS_LIST },
    { label: 'Онлайн-курсы', list: EDUCATION_OFFERS_LIST },
    { label: 'Бизнес', list: BUSINESS_OFFERS_LIST },
    { label: 'Страхование', list: INSURANCE_OFFERS_LIST },
];
var PopoverHeading = function (_a) {
    var _b;
    var element = _a.element, activeTabType = _a.activeTabType, tabs = _a.tabs, onTabChange = _a.onTabChange, isLimitTabsCount = _a.isLimitTabsCount;
    var cx = useStyles(modules_31ab199a);
    var isMobile = useIsMobile();
    var _c = __read(useBoolean(), 2), isPopupVisible = _c[0], setPopupVisibility = _c[1];
    var tabsToShow = allTabsForMenu;
    if (isLimitTabsCount) {
        tabsToShow = allTabsForMenu.reduce(function (acc, _a) {
            var label = _a.label, list = _a.list;
            var availableTabs = list.filter(function (tab) { return hasItem(tabs, tab); });
            if (!availableTabs.length)
                return acc;
            return __spreadArray(__spreadArray([], __read(acc), false), [{ label: label, list: availableTabs }], false);
        }, []);
    }
    if (((_b = tabs[0]) === null || _b === void 0 ? void 0 : _b.type) === INSURANCE_OFFERS.insuranceOsago) {
        return React__default.cloneElement(React__default.createElement(React__default.Fragment, null), {}, null);
    }
    var popupLayoutContent = (React__default.createElement(Accordion, { defaultIndex: [0], separator: 'divider' }, tabsToShow.map(function (_a) {
        var label = _a.label, list = _a.list;
        var labelElement = (React__default.createElement(Space, { direction: 'horizontal', size: 8, align: 'center' },
            React__default.createElement("span", null, label),
            React__default.createElement(Badge, { variant: 'primary', color: 'blue', text: list.length, className: cx('menu__heading__badge') })));
        return (React__default.createElement(Accordion.Item, { title: labelElement, className: cx('accordion-item'), key: "label-".concat(label) },
            React__default.createElement(Menu, { className: cx('menu') }, list.map(function (tab) {
                var handleMenuItemClick = function () {
                    onTabChange(tab);
                    setPopupVisibility.off();
                };
                return (React__default.createElement(Menu.Item, { key: generateKeyFromTab(tab), active: tab.type === activeTabType.type && tab.subtype === activeTabType.subtype, onClick: handleMenuItemClick },
                    React__default.createElement("span", { className: cx('menu__item') }, getTabTitle(tab))));
            }))));
    })));
    var children = tabs.length === 1 ? ("".concat(generateHeadingTitle(activeTabType), " ").concat(getTabTitleTo(activeTabType))) : (React__default.createElement(React__default.Fragment, null,
        generateHeadingTitle(activeTabType),
        ' ',
        React__default.createElement(Typography.Link, { onClick: setPopupVisibility.on }, getTabTitleTo(activeTabType)),
        !isMobile && (React__default.createElement(Dialog, { visible: isPopupVisible, onClose: setPopupVisibility.off, className: cx('dialog') },
            React__default.createElement(Dialog.Header, { title: "\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }),
            React__default.createElement(Dialog.Content, null, popupLayoutContent))),
        isMobile && (React__default.createElement(Sheet, { visible: isPopupVisible, onClose: setPopupVisibility.off, closable: true, fullscreen: true },
            React__default.createElement(Sheet.Header, { title: 'Интересные предложения' }),
            React__default.createElement(Sheet.Content, null, popupLayoutContent)))));
    var propsForCloningElement = __assign(__assign({}, element.props), { className: cn('h-mb-20', element.props.className) });
    return React__default.cloneElement(element, propsForCloningElement, children);
};

var Headings$1 = function (_a) {
    var type = _a.type, heading = _a.heading, tabs = _a.tabs, activeTabType = _a.activeTabType, setActiveTabType = _a.setActiveTabType, horizontalText = _a.horizontalText, showOneHorizontalTabHeading = _a.showOneHorizontalTabHeading, isLimitTabsCount = _a.isLimitTabsCount;
    if (!activeTabType)
        return null;
    var handleTabChange = function (tab) {
        setActiveTabType(tab);
    };
    var props = {
        tabs: tabs,
        element: heading,
        activeTabType: activeTabType,
        onTabChange: handleTabChange
    };
    if (type === 'horizontal') {
        return (React__default.createElement(HorizontalHeading, __assign({}, props, { horizontalText: horizontalText, showOneHorizontalTabHeading: showOneHorizontalTabHeading })));
    }
    return React__default.createElement(PopoverHeading, __assign({ isLimitTabsCount: isLimitTabsCount }, props));
};

var modules_3999ddfa = {"iframe":"_1l4tscn"};
/*SRAVNI__src/innerComponents/UltimateSpecialOffers/src/components/Iframe/Iframe.module.scss__SRAVNI*/;

var sendMessageToSpecialOffersFrontend = function (iframeRef, payload) {
    var _a, _b;
    (_b = (_a = iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({
        source: 'special-offers-iframe-wrapper',
        payload: payload
    }, '*');
};
var Iframe$1 = function (_a) {
    var iframeSrc = _a.iframeSrc, domain = _a.domain, pushEvent = _a.pushEvent, propsIframeId = _a.iframeId, onLoad = _a.onLoad, setItemsCount = _a.setItemsCount, activeTabType = _a.activeTabType, maxDesktopVisibleItems = _a.maxDesktopVisibleItems, handleReceivingAvailableTabs = _a.handleReceivingAvailableTabs, tabs = _a.tabs, _b = _a.isWithLinkToAll, isWithLinkToAll = _b === void 0 ? true : _b;
    var _c = __read(useState(0), 2), iframeHeight = _c[0], setIframeHeight = _c[1];
    var isMobile = useIsMobile();
    var _d = __read(useTheme(), 1), theme = _d[0];
    var _e = __read(useBoolean(false), 2), isLoaded = _e[0], setLoaded = _e[1];
    var iframeRef = useRef(null);
    var handleLoad = function () {
        setLoaded.on();
        onLoad && onLoad();
    };
    useEffect(function () {
        var listener = function (_a) {
            var origin = _a.origin, data = _a.data;
            var source = data.source, payload = data.payload;
            if (origin !== domain || source !== 'special-offers')
                return;
            var height = payload.height, url = payload.url, type = payload.type, event = payload.event, iframeId = payload.iframeId, itemsCount = payload.itemsCount, availableTabs = payload.availableTabs;
            if (iframeId !== propsIframeId)
                return;
            if (type === 'itemsCount') {
                setItemsCount(itemsCount);
                return;
            }
            if (type === 'generalLinkClick') {
                window.top ? (window.top.location.href = url) : (window.location.href = url);
                return;
            }
            if (type === 'changeHeight') {
                setIframeHeight(height);
                return;
            }
            if (type === 'pushEvent') {
                pushEvent(event);
                return;
            }
            if (type === 'listenerIsAdded') {
                handleLoad();
                return;
            }
            if (type === 'availableTabs') {
                handleReceivingAvailableTabs(availableTabs);
                return;
            }
        };
        window.addEventListener('message', listener);
        return function () {
            window.removeEventListener('message', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domain, handleReceivingAvailableTabs, propsIframeId, pushEvent, setItemsCount, setLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeTheme',
            theme: theme
        });
    }, [isLoaded, theme]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeIsMobile',
            isMobile: isMobile
        });
    }, [isLoaded, isMobile]);
    useEffect(function () {
        if (!isLoaded || !activeTabType)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'activeTabType',
            activeTabType: activeTabType
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabType === null || activeTabType === void 0 ? void 0 : activeTabType.subtype, activeTabType === null || activeTabType === void 0 ? void 0 : activeTabType.type, isLoaded]);
    var tabsDeps = JSON.stringify(tabs);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'allTabs',
            allTabs: tabs
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded, tabsDeps]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'maxDesktopVisibleItems',
            maxDesktopVisibleItems: maxDesktopVisibleItems
        });
    }, [maxDesktopVisibleItems, isLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'pageUrl',
            pageUrl: document.location.href
        });
    }, [isLoaded]);
    useEffect(function () {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'isWithLinkToAll',
            isWithLinkToAll: isWithLinkToAll
        });
    }, [isLoaded, isWithLinkToAll]);
    return (React__default.createElement("iframe", { height: "".concat(iframeHeight, "px"), style: { minHeight: "".concat(iframeHeight, "px"), maxHeight: "".concat(iframeHeight, "px") }, className: cn(modules_3999ddfa.iframe), src: iframeSrc, title: 'Интересные предложения', ref: iframeRef }));
};

var calculatePreloaderItemsCount = function (_a) {
    var activeTabType = _a.activeTabType, insidePopup = _a.insidePopup, isMobile = _a.isMobile, isNarrowOnDesktop = _a.isNarrowOnDesktop, isVerticalOnMobile = _a.isVerticalOnMobile, maxDesktopVisibleItems = _a.maxDesktopVisibleItems;
    if (isEqual_1(activeTabType, { type: INSURANCE_OFFERS.insuranceOsago }))
        return 1;
    if (insidePopup)
        return 4;
    if (isMobile) {
        return isVerticalOnMobile ? 3 : 4;
    }
    if (isNarrowOnDesktop) {
        return 3;
    }
    if (activeTabType && hasItem(ACTIONS_LIST, activeTabType)) {
        return 4;
    }
    return maxDesktopVisibleItems || 8;
};

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

const POOL_SIZE_MULTIPLIER = 128;
let pool, poolOffset;
let fillPool = bytes => {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto.randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto.randomFillSync(pool);
    poolOffset = 0;
  }
  poolOffset += bytes;
};
let nanoid = (size = 21) => {
  fillPool((size -= 0));
  let id = '';
  for (let i = poolOffset - size; i < poolOffset; i++) {
    id += urlAlphabet[pool[i] & 63];
  }
  return id
};

var useGenerateSpecialUrl = function (_a) {
    var propsIframeSrc = _a.propsIframeSrc, params = _a.params, firstTab = _a.firstTab, type = _a.type;
    var _b = __read(useState(''), 2), iframeDomain = _b[0], setIframeDomain = _b[1];
    var _c = __read(useState(''), 2), iframeSrc = _c[0], setIframeSrc = _c[1];
    var _d = __read(useState(nanoid), 1), iframeId = _d[0];
    var defaultUrl = "".concat(iframeDomain, "/special-offers/").concat(type === 'verticalList' ? 'vertical/' : '');
    useEffect(function () {
        if (propsIframeSrc) {
            setIframeDomain(propsIframeSrc);
        }
        else {
            setIframeDomain(window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : ''));
        }
    }, [propsIframeSrc]);
    useEffect(function () {
        if (!iframeDomain)
            return;
        var allParams = __assign(__assign({}, params), { iframeId: iframeId });
        var url = new URL(defaultUrl);
        Object.entries(allParams).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (Array.isArray(value)) {
                value.forEach(function (v) { return url.searchParams.append(key, v); });
            }
            else if (value) {
                url.searchParams.set(key, value.toString());
            }
        });
        url.searchParams.set('firstTab', firstTab.type);
        if (firstTab.subtype) {
            url.searchParams.set('subproduct', firstTab.subtype);
        }
        if (type === 'verticalList') {
            url.searchParams.set('tabType', firstTab.type);
            firstTab.subtype && url.searchParams.set('subproduct', firstTab.subtype);
        }
        setIframeSrc(url.toString());
    }, [defaultUrl, firstTab, iframeDomain, iframeId, params, type]);
    return {
        iframeDomain: iframeDomain,
        iframeSrc: iframeSrc,
        iframeId: iframeId
    };
};

var modules_16ab616e = {"wrapper":"_dwzhj9"};
import "../assets/SpecialOffers.css";

var UltimateSpecialOffers$1 = function (_a) {
    var _b = _a.headingType, headingType = _b === void 0 ? 'popover' : _b, heading = _a.heading, horizontalTitle = _a.horizontalTitle, propsIframeSrc = _a.iframeSrc, isBVersion = _a.isBVersion, onTabChange = _a.onTabChange, abName = _a.abName, _c = _a.tabs, propsTabs = _c === void 0 ? OFFERS_TABS_DEFAULT_ORDER : _c, isWithButtons = _a.isWithButtons, _d = _a.insidePopup, insidePopup = _d === void 0 ? false : _d, _e = _a.isNarrowOnDesktop, isNarrowOnDesktop = _e === void 0 ? false : _e, onLoad = _a.onLoad, propsSetItemsCount = _a.setItemsCount, bonusFilter = _a.bonusFilter, _f = _a.maxDesktopVisibleItems, maxDesktopVisibleItems = _f === void 0 ? 8 : _f, className = _a.className, propsActiveTab = _a.activeTab, organizationId = _a.organizationId, onReceivingAvailableTabs = _a.onReceivingAvailableTabs, showOneHorizontalTabHeading = _a.showOneHorizontalTabHeading, _g = _a.isVerticalOnMobile, isVerticalOnMobile = _g === void 0 ? false : _g, onHeightChange = _a.onHeightChange, _h = _a.type, type = _h === void 0 ? 'common' : _h, props = __rest(_a, ["headingType", "heading", "horizontalTitle", "iframeSrc", "isBVersion", "onTabChange", "abName", "tabs", "isWithButtons", "insidePopup", "isNarrowOnDesktop", "onLoad", "setItemsCount", "bonusFilter", "maxDesktopVisibleItems", "className", "activeTab", "organizationId", "onReceivingAvailableTabs", "showOneHorizontalTabHeading", "isVerticalOnMobile", "onHeightChange", "type"]);
    var tabs = normalizeTabs(propsTabs);
    var propsActiveTabNormalized = propsActiveTab && normalizeTab(propsActiveTab);
    // const isFirstRenderRef = useRef<boolean>(true);
    var _j = __read(useBoolean(true), 2), isIframeLoading = _j[0], setIframeLoading = _j[1];
    var isMobile = useIsMobile();
    var _k = __read(useState(null), 2), itemsCount = _k[0], setItemsCount = _k[1];
    var _l = __read(useState(), 2), activeTabType = _l[0], setActiveTabType = _l[1];
    var wrapperRef = useRef(null);
    var firstTab = useMemo(function () {
        return propsActiveTabNormalized !== null && propsActiveTabNormalized !== void 0 ? propsActiveTabNormalized : tabs === null || tabs === void 0 ? void 0 : tabs[0];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _m = useGenerateSpecialUrl({
        propsIframeSrc: propsIframeSrc,
        params: {
            isBVersion: isBVersion,
            abName: abName,
            isWithButtons: isWithButtons,
            isPopup: insidePopup,
            bonusFilter: bonusFilter,
            organizationId: organizationId,
            isVerticalOnMobile: isVerticalOnMobile
        },
        firstTab: firstTab,
        type: type
    }), iframeDomain = _m.iframeDomain, iframeSrc = _m.iframeSrc, iframeId = _m.iframeId;
    var depsString = JSON.stringify(tabs);
    useEffect(function () {
        setActiveTabType(propsActiveTabNormalized !== null && propsActiveTabNormalized !== void 0 ? propsActiveTabNormalized : tabs[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propsActiveTabNormalized, depsString]);
    useEffect(function () {
        if (!activeTabType)
            return;
        onTabChange && onTabChange(activeTabType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabType === null || activeTabType === void 0 ? void 0 : activeTabType.type, activeTabType === null || activeTabType === void 0 ? void 0 : activeTabType.subtype, onTabChange]);
    useEffect(function () {
        var element = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current;
        if (!element)
            return;
        var resizeObserver = new ResizeObserver(function (entries) {
            var e_1, _a;
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var entry = entries_1_1.value;
                    if (entry.borderBoxSize) {
                        onHeightChange && onHeightChange(entry.borderBoxSize[0].blockSize);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1["return"])) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        resizeObserver.observe(element);
        return function () { return resizeObserver.disconnect(); };
    }, [onHeightChange, iframeSrc]);
    if (!iframeSrc)
        return null;
    var handleLoad = function () {
        setIframeLoading.off();
        onLoad && onLoad();
    };
    var preloaderItemsCount = calculatePreloaderItemsCount({
        activeTabType: activeTabType,
        insidePopup: insidePopup,
        isMobile: isMobile,
        isNarrowOnDesktop: isNarrowOnDesktop,
        isVerticalOnMobile: isVerticalOnMobile,
        maxDesktopVisibleItems: maxDesktopVisibleItems
    });
    var handleItemsCount = function (count) {
        setItemsCount(count);
        propsSetItemsCount && propsSetItemsCount(count);
    };
    var handleReceivingAvailableTabs = function (tabs) {
        onReceivingAvailableTabs && onReceivingAvailableTabs(tabs);
    };
    return (React__default.createElement("div", { className: cn(modules_16ab616e.wrapper, className), ref: wrapperRef },
        !!heading && (React__default.createElement(Headings$1, { type: headingType, heading: heading, tabs: tabs, activeTabType: activeTabType, setActiveTabType: setActiveTabType, horizontalText: horizontalTitle, showOneHorizontalTabHeading: showOneHorizontalTabHeading, isLimitTabsCount: !!organizationId })),
        (isIframeLoading || itemsCount === null) && type !== 'verticalList' && (React__default.createElement(BlockListPreloader, { itemsCount: preloaderItemsCount, isPopup: insidePopup, isVerticalOnMobile: isVerticalOnMobile })),
        React__default.createElement("div", { style: { height: isIframeLoading || itemsCount === null ? '0px' : 'auto', overflow: 'hidden' } },
            React__default.createElement(Iframe$1, __assign({ iframeSrc: iframeSrc, domain: iframeDomain, iframeId: iframeId, onLoad: handleLoad, activeTabType: activeTabType, setItemsCount: handleItemsCount, maxDesktopVisibleItems: maxDesktopVisibleItems, handleReceivingAvailableTabs: handleReceivingAvailableTabs, tabs: tabs }, props)))));
};

export { UltimateSpecialOffers$1 as U };
